import * as yup from 'yup';

export type ValidationSeverity = 'error' | 'warning';

export interface ValidationMessage {
  path: string;
  message: string;
  severity: ValidationSeverity;
}

export interface ValidationResult {
  valid: boolean;
  messages: ValidationMessage[];
}

/**
 * Validates data against a Yup schema and returns the validation result.
 *
 * @param data - The data to validate.
 * @param schema - The Yup schema to validate against.
 * @returns An object containing the validation result and any error messages.
 */
export const validateSchema = <T>(
  data: T,
  schema: yup.Schema
): ValidationResult => {
  try {
    schema.validateSync(data, { abortEarly: false });
    return { valid: true, messages: [] };
  } catch (error) {
    if (error instanceof yup.ValidationError) {
      return {
        valid: false,
        messages: error.inner.map((err) => ({
          path: err.path || 'unknown',
          message: err.message,
          severity: 'error',
        })),
      };
    }
    return {
      valid: false,
      messages: [
        { path: 'unknown', message: String(error), severity: 'error' },
      ],
    };
  }
};
